var defaults = {
  blur: "5px",
  brightness: 1,
  saturation: 1,
  y: 0,
  x: 0
};

const createWrapperClass = className => {
  const created = document.getElementById(`${className}-class`);

  if (created) {
    created.parentElement.removeChild(created);
  }

  const styles = document.createElement("style");
  styles.setAttribute("id", `${className}-class`);
  styles.textContent = `
      .${className}-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
      }
  `;
  document.head.appendChild(styles);
};

const createCloneStyles = (currentStyles, options) => {
  const {
    blur,
    brightness,
    saturation,
    x,
    y,
    index
  } = options;
  const mergedStyles = currentStyles.cssText + `
    position: absolute;
    filter: blur(${blur}) brightness(${brightness}) saturate(${saturation});
    z-index: -1;
    transform: translate3d(${x}, ${y}, 0);
  `;
  return mergedStyles;
};

const className = "cosha";

const cosha = (el, options, vnode) => {
  if (!el) return console.warn("[vue-cosha]: Element doesn't exist!");
  if (vnode.tag !== "img") return console.warn("[vue-cosha]: Directive must be on an image");
  createWrapperClass(className);
  const parent = el.parentNode;
  const hasBeenCreated = parent.classList.contains(`${className}-wrapper`);

  if (!hasBeenCreated) {
    const wrapper = document.createElement("div");
    const clonedNode = el.cloneNode(true);
    wrapper.classList.add(`${className}-wrapper`);
    clonedNode.classList.add(`${className}-clone`);
    clonedNode.style.cssText = createCloneStyles(clonedNode.style, options);
    clonedNode.setAttribute("alt", "");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    wrapper.appendChild(clonedNode);
  }

  if (hasBeenCreated) {
    const clonedChild = [...el.parentNode.children].find(child => child.classList.contains(`${className}-clone`));
    clonedChild.style.cssText = createCloneStyles(clonedChild.style, options);
  }
};

var cosha$1 = (options => {
  const mergedOptions = Object.assign(defaults, options);

  const inserted = (el, {
    value
  }, vnode) => {
    const mergedValues = Object.assign(mergedOptions, value);
    return cosha(el, mergedValues, vnode);
  };

  const update = (el, {
    value
  }, vnode) => {
    const mergedValues = Object.assign(mergedOptions, value);
    return cosha(el, mergedValues, vnode);
  };

  return {
    inserted,
    update
  };
});

const plugin = {
  install(Vue, options) {
    Vue.directive("cosha", cosha$1(options));
  }

};

export { plugin as default };
